/*!jslint
  this
*/
jQuery(function ($) {
  "use strict";
 

  $(document).on("click", ".scroll-to", function(e) {
      var href = $(this).attr("href");
      var offsetTop = href === "#" ? 0 : $(href).offset().top;
      var HdTop = $(".site-header").outerHeight();
      $("html, body").stop().animate({
          scrollTop: offsetTop - HdTop
      }, 500);
      e.preventDefault();
    });
  $(document).on('click', '.nav-toggle', function(){
    $(this).toggleClass('on');
    $('html').toggleClass('nav-on');
  });
  $(document).on('click', '.mobile-navigation li.menu-item-has-children > a', function(e){
    e.preventDefault();
    $(this).toggleClass('open');
    $(this).next().slideToggle();
  });
  
   function appHeight() {
      var wh = $(window).innerHeight();
      document.documentElement.style
        .setProperty('--app-height', wh + 'px');

    }
    window.addEventListener('resize', appHeight)
    appHeight();
    function rtl_slick() {
      if ($('body').hasClass("rtl")) {
        return true;
      } else {
        return false;
      }
    }
    $('.banner-block-slider').slick({
      dots: true,
      infinite: true,
      arrows: false, 
      fade: true,
      rtl: rtl_slick(),
      pauseOnHover: false,
    });
    $('.simple-img-cl').slick({
      dots: false,
      infinite: true,
      arrows: true, 
      fade: true,
      rtl: rtl_slick(),
      autoplaySpeed: 5000,
      pauseOnHover: false,
      nextArrow: '<span class="slick-arrow slick-next"><svg fill="none" width="8" height="14" viewBox="0 0 8 14" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin" fill="none"><path xmlns="http://www.w3.org/2000/svg" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" d="M1 13L5.93939 8.06061C6.52273 7.47727 6.52273 6.52273 5.93939 5.93939L1 1"/></svg></span>',
      prevArrow: '<span class="slick-arrow slick-prev"><svg fill="none" width="8" height="14" viewBox="0 0 8 14" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin" fill="none"><path xmlns="http://www.w3.org/2000/svg" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" d="M6.2793 13L1.3399 8.06061C0.756569 7.47727 0.756569 6.52273 1.3399 5.93939L6.2793 1"/></svg></span>',
    });
    $('.banner-block-slider-alt').slick({
      dots: false,
      autoplay: true,
      infinite: true,
      arrows: false, 
      fade: true,
      rtl: rtl_slick(),
      autoplaySpeed: 5000,
      pauseOnHover: false,
    });
    
    $('.page-banner-slider').slick({
      dots: false,
      infinite: true,
      autoplay: true,
      arrows: false, 
      fade: true,      
      rtl: rtl_slick(),
      autoplaySpeed: 5000,
      pauseOnHover: false,
    });
    if($('.banner-block-slider').length){
      var items = $('.banner-block-slider .slick-dots').find('li').length;
      if(items > 4){
        $('.banner-block-slider-item-content').css('min-width', (388 + (items - 4)* 77));
      }
    }
    
    $('.explore-block-cl').slick({
      dots: false,
      infinite: true,
      arrows: false, 
      slidesToShow: 3,
      slidesToScroll: 1,
      rtl: rtl_slick(),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 678,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
    $('.payment-block-cl').slick({
      dots: true,
      infinite: false,
      arrows: false, 
      slidesToShow: 4,
      slidesToScroll: 4,
      rtl: rtl_slick(),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 678,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });
    
    $('.floorplan-tab-cl').slick({
      dots: false,
      infinite: true,
      arrows: true, 
      variableWidth: true,
      nextArrow: '<span class="slick-arrow slick-next"><svg fill="none" width="14" height="10" viewBox="0 0 14 10" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin"><path xmlns="http://www.w3.org/2000/svg" stroke="#FFFBFB" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" d="M8.61998 0.999931L12.6666 5.0466L8.61998 9.09326M1.33331 5.0466L12.5533 5.0466"/></svg></span>',
      prevArrow: '<span class="slick-arrow slick-prev"><svg fill="none" width="14" height="10" viewBox="0 0 14 10" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin"><path xmlns="http://www.w3.org/2000/svg" stroke="#FFFBFB" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" d="M5.04665 0.999931L0.999978 5.0466L5.04665 9.09326M12.3333 5.0466L1.11331 5.0466"/></svg></span>',
      rtl: rtl_slick(),
    });
       $('[data-fancybox]').fancybox({
        // Options will go here
        arrows  : false,
        afterLoad : function( instance, current ) {
                        if ( instance.group.length > 1 && current.$content ) {
                          current.$content.append('\
                                <a data-fancybox-next class="button-next fancybox-button fancybox-button--arrow_right" href="javascript:;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"></path></svg></a>\
                                <a data-fancybox-prev class="button-previous fancybox-button fancybox-button--arrow_left" href="javascript:;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"></path></svg></a>\
                            ');
                          setTimeout(function() {
                            $('.button-previous, .button-next').show()
                          },500);
                          
                        }
        }
        
    });
    if($('.banner-block').length || $('.page-banner').length){

    }else{
      $('body').addClass('no-banner');
    }
    $(document).on('click', '.retail-brand-tab-cl-item', function(e){
      var ID = $(this).data('id');
      $('.retail-brand-tab-cl-item').removeClass('active');
      $(this).addClass('active');
      if($(this).hasClass('show-all')){
        $('.retail-brand-item').show();
      }else{
        $('.retail-brand-item').hide();
        $(ID).show();
      }
    });
    $('.open-enquiry').on('click', function (e){
      $('#input_3_9').val($(this).data('property'));
    });
    $(".retail-brand-list a, .model-popup, nav .btn-style a, .ns-fp-image-in a").fancybox();
    $('[data-3dtour]').on('click', function (e){
      e.preventDefault();
      var src = $(this).data('3dtour');

      $.fancybox.open({
        src  : src,
        type : 'iframe',
        opts : {
          afterShow : function( instance, current ) {

          }
        }
      });

    });
    $(document).on('click', '.bank-info-list-item-head', function(e){
      $('.bank-info-list-item').removeClass('item-open');
      $('.bank-info-list-item-content').slideUp('normal');
      if($(this).next().is(':hidden') == true) {
        $(this).parent().addClass('item-open');
        $(this).next().slideDown('normal');
      }
     });
    
     var min=$('#price-min').val(),max=$('#price-max').val();
     $( "#slider-range" ).slider({
      range: true,
      min: 0,
      max: 3000000,
      values: [ min, max ],
      slide: function( event, ui ) {
        $( "#min-price" ).html( nFormatter(ui.values[ 0 ],1));
        $( "#max-price" ).html( nFormatter(ui.values[ 1 ],1) );

        $( "#price-min" ).val( ui.values[ 0 ]);
        $( "#price-max" ).val( ui.values[ 1 ] );
      }
    });
    function nFormatter(num, digits) {
      const lookup = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "k" },
        { value: 1e6, symbol: "M" },
        { value: 1e9, symbol: "G" },
        { value: 1e12, symbol: "T" },
        { value: 1e15, symbol: "P" },
        { value: 1e18, symbol: "E" }
      ];
      const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
      var item = lookup.slice().reverse().find(function(item) {
        return num >= item.value;
      });
      return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
    }

    jQuery(document).on('gform_confirmation_loaded', function(event, formId){
      if($('.gformcustom-redirection-link').length){
        setTimeout(function(){  window.location = $('.gformcustom-redirection-link').attr('href'); } , 3000);   
        $('#register-interest h2,#register-interest .enquiry-popup-r  img').hide();
      }
      
  }); 
    $(document).on('click', '.floorplan-prop-item .button', function(){
      $('#register-interest .enquiry-popup-l img').attr('src', $(this).data('image'));
      $('#register-interest .enquiry-popup-r img').attr('src', $(this).data('logo'));
    });
});